import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Layout } from './components/Layout/Layout';
import { SproutIcon, LeafIcon, SearchIcon, Users, Briefcase, LayoutDashboard } from 'lucide-react';
export function App() {
  const navigate = useNavigate();
  return <Layout data-id="element-0">
      <div className="flex flex-col items-center justify-center w-full min-h-[calc(100vh-8rem)] p-4 md:p-8" data-id="element-1">
        <div className="text-center max-w-3xl" data-id="element-2">
          <div className="flex justify-center mb-6" data-id="element-3">
            <div className="bg-leaf-green rounded-full p-4" data-id="element-4">
              <SproutIcon size={48} className="text-white" data-id="element-5" />
            </div>
          </div>
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-soil-brown mb-4" data-id="element-6">
            GrowConnect
          </h1>
          <p className="text-lg md:text-xl text-gray-700 mb-8" data-id="element-7">
            Connecting farmers, investors, and agricultural projects for a
            sustainable future
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-8">
            {[{
            icon: <SearchIcon size={32} className="text-leaf-green mb-2" data-id="element-9" />,
            title: 'Discover Projects',
            description: 'Find agricultural projects that align with your goals and values'
          }, {
            icon: <SproutIcon size={32} className="text-leaf-green mb-2" data-id="element-10" />,
            title: 'Match Deals',
            description: 'Connect with investors and farmers for mutual growth'
          }, {
            icon: <LeafIcon size={32} className="text-leaf-green mb-2" data-id="element-11" />,
            title: 'Track Progress',
            description: 'Monitor your agricultural projects from seed to harvest'
          }].map((feature, index) => <div key={index} className="card flex flex-col items-center text-center p-6" data-id="element-12">
                {feature.icon}
                <h3 className="text-xl font-semibold mb-2" data-id="element-13">{feature.title}</h3>
                <p className="text-gray-600" data-id="element-14">{feature.description}</p>
              </div>)}
          </div>
          <div className="flex flex-col sm:flex-row justify-center gap-4 mb-8" data-id="element-15">
            <button onClick={() => navigate('/login')} className="btn btn-primary text-lg px-8 py-3" data-id="element-16">
              Sign In
            </button>
            <button onClick={() => navigate('/onboarding')} className="btn btn-outline text-lg px-8 py-3" data-id="element-17">
              Get Started
            </button>
          </div>
          <div className="mt-10" data-id="element-18">
            <h2 className="text-xl font-semibold mb-4" data-id="element-19">Choose Your Role</h2>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4" data-id="element-20">
              <div onClick={() => navigate('/login')} className="bg-white p-6 rounded-lg shadow-sm border border-gray-200 hover:border-leaf-green cursor-pointer transition-colors" data-id="element-21">
                <div className="flex flex-col items-center" data-id="element-22">
                  <div className="bg-green-100 p-3 rounded-full mb-3" data-id="element-23">
                    <Users size={24} className="text-green-600" data-id="element-24" />
                  </div>
                  <h3 className="font-medium" data-id="element-25">GrowConnect Admin</h3>
                  <p className="text-sm text-gray-600 mt-2 text-center" data-id="element-26">
                    Manage the platform, users, and agricultural projects
                  </p>
                  <div className="mt-4 flex items-center text-leaf-green text-sm" data-id="element-27">
                    <LayoutDashboard size={16} className="mr-1" data-id="element-28" />
                    Admin Dashboard
                  </div>
                </div>
              </div>
              <div onClick={() => navigate('/login')} className="bg-white p-6 rounded-lg shadow-sm border border-gray-200 hover:border-leaf-green cursor-pointer transition-colors" data-id="element-29">
                <div className="flex flex-col items-center" data-id="element-30">
                  <div className="bg-blue-100 p-3 rounded-full mb-3" data-id="element-31">
                    <Briefcase size={24} className="text-blue-600" data-id="element-32" />
                  </div>
                  <h3 className="font-medium" data-id="element-33">Investor</h3>
                  <p className="text-sm text-gray-600 mt-2 text-center" data-id="element-34">
                    Discover and invest in promising agricultural projects
                  </p>
                  <div className="mt-4 flex items-center text-leaf-green text-sm" data-id="element-35">
                    <LayoutDashboard size={16} className="mr-1" data-id="element-36" />
                    Investor Dashboard
                  </div>
                </div>
              </div>
              <div onClick={() => navigate('/login')} className="bg-white p-6 rounded-lg shadow-sm border border-gray-200 hover:border-leaf-green cursor-pointer transition-colors" data-id="element-37">
                <div className="flex flex-col items-center" data-id="element-38">
                  <div className="bg-amber-100 p-3 rounded-full mb-3" data-id="element-39">
                    <SproutIcon size={24} className="text-amber-600" data-id="element-40" />
                  </div>
                  <h3 className="font-medium" data-id="element-41">Farmer</h3>
                  <p className="text-sm text-gray-600 mt-2 text-center" data-id="element-42">
                    List your agricultural projects and connect with investors
                  </p>
                  <div className="mt-4 flex items-center text-leaf-green text-sm" data-id="element-43">
                    <LayoutDashboard size={16} className="mr-1" data-id="element-44" />
                    Farmer Dashboard
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>;
}